<template>
  <div class="uesr-layout">
    <div class="left">
      <!-- 欢迎信息 -->
      <div class="l-top">
        <div class="lt-info">
          <img class="avatar" src="@/assets/image/avatar.png" />
          <div class="lt-welcome">
            <div class="ltw-top">
              <span class="ltw-tips"
                >{{ welcome }}{{ info.nickname || user.id }}</span
              >
              <router-link to="/user/account/">
                <img class="u-icon" src="@/assets/image/u-user-icon.png" />
              </router-link>
              <router-link to="/user/account/security">
                <img class="u-icon" src="@/assets/image/u-phone-icon.png" />
              </router-link>
              <router-link to="/user/account/security">
                <img class="u-icon" src="@/assets/image/u-email-icon.png" />
              </router-link>
            </div>
            <div class="lg-record" style="margin-top: 6px">
              <span>上次登录：{{ info.lastLoginAt }}</span
              ><span style="margin-left: 10px"
                >{{ info.lastLoginIp }} {{ info.lastLoginAddress }}</span
              >
            </div>
          </div>
        </div>
        <div class="level" v-if="info.level">{{ info.level }}</div>
      </div>
      <!-- 账户信息 -->
      <div class="l-main">
        <div class="item wallet">
          <img src="@/assets/image/u-wallet-icon.png" />
          <span>我的钱包</span>
        </div>
        <div class="lm-item">
          <span>{{ balance.toFixed(2) }}</span>
          <span class="lmi-text">可用余额</span>
        </div>
        <div class="lm-item">
          <span>{{ freezeAmount.toFixed(2) }}</span>
          <span class="lmi-text">冻结余额</span>
        </div>
      </div>
      <!-- 预定 -->
      <div class="l-bottom">
        <div class="lb-title">
          <span class="title">我的域名</span>
          <router-link class="to-more" to="/user/domain"
            >查看全部 ></router-link
          >
        </div>
        <div class="lb-main">
          <div class="item">
            <span class="count">{{ info.domainCount }}</span>
            <span>我拥有的域名</span>
          </div>
          <div class="item">
            <span class="count">{{ info.redeemDomainCount }}</span>
            <span>赎回期的域名</span>
          </div>
          <div class="item">
            <span class="count">{{ info.pushingCount }}</span>
            <span>待接收的push域名</span>
          </div>
          <div class="item">
            <span class="count">{{ info.templateCount }}</span>
            <span>域名模板的数量</span>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="rt-bottom rb-bottom">
        <div class="rt-title">
          <span class="title">我的域名</span>
          <router-link class="to-more" to="/user/domain"
            >查看全部 ></router-link
          >
        </div>
        <div class="rt-section">
          <router-link class="item" to="/user/domain">我的域名</router-link>
          <router-link class="item" to="/user/template">我的模板</router-link>
          <router-link class="item" to="/user/transferout"
            >我的转出</router-link
          >
          <router-link class="item" to="/user/transferin">我的转入</router-link>
          <router-link class="item" to="/user/push">域名PUSH</router-link>
          <router-link class="item" to="/user/order">域名订单</router-link>
          <!-- <router-link class="item" to=""
            >即将到期域名 (<span>{{ info.expiringDomainCount }}</span
            >)</router-link
          >
          <router-link class="item" to=""
            >已到期域名 (<span>{{ info.expiredDomainCount }}</span
            >)</router-link
          >
          <router-link class="item" to=""
            >赎回期域名 (<span>{{ info.redeemDomainCount }}</span
            >)</router-link
          >
          <router-link class="item" to=""
            >正在转入 (<span>{{ info.transferIntoCount }}</span
            >)</router-link
          >
          <router-link class="item" to=""
            >正在转出 (<span>{{ info.transferOutCount }}</span
            >)</router-link
          >
          <router-link class="item" to=""
            >等待接收的PUSH (<span>{{ info.pushingCount }}</span
            >)</router-link
          >
          <router-link class="item" to=""
            >我发出的PUSH (<span>{{ info.pushCount }}</span
            >)</router-link
          >
          <router-link class="item" to=""
            >域名模板 (<span>{{ info.templateCount }}</span
            >)</router-link
          > -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { userInfo } from "api/user.js";
export default {
  name: "user",
  data() {
    return {
      info: {},
    };
  },
  computed: {
    ...mapState(["user", "freezeAmount", "balance"]),
    welcome() {
      let title = "";
      let hours = new Date().getHours();
      if (hours < 12) {
        title = "上午好！";
      } else if (hours >= 12 && hours < 14) {
        title = "中午好！";
      } else if (hours >= 14 && hours < 19) {
        title = "下午好！";
      } else if (hours >= 19 && hours <= 24) {
        title = "晚上好！";
      }
      return title;
    },
  },
  created() {
    this.req_userInfo();
  },
  methods: {
    async req_userInfo() {
      try {
        const { code, data } = await userInfo();
        if (code === 200) {
          this.info = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.uesr-layout {
  display: flex;
  justify-content: space-between;
  min-height: 100%;
  padding: 50px 60px 81px;
  background-color: #f0f3f6;
  .left {
    // flex: 0 1 820px;
    flex: 4.9;
    .l-top {
      padding: 56px 48px 48px;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      .avatar {
        width: 36px;
        height: 36px;
        margin-right: 10px;
      }
      .lt-info {
        display: flex;
        .ltw-top {
          display: flex;
          align-items: center;
          .ltw-tips {
            color: #3992e9;
            font-size: 18px;
            font-weight: bold;
            margin-right: 10px;
          }
        }
      }
      .u-icon {
        width: 22px;
        height: 22px;
        margin-right: 10px;
      }
      .lg-record {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
    }
    .level {
      border-radius: 30px;
      padding: 0 22px;
      text-align: center;
      height: 37px;
      line-height: 37px;
      color: #fff;
      background-color: #3992e9;
      align-self: center;
    }
    .l-main {
      background: url("~@/assets/image/u-zh-icon.png");
      background-size: cover;
      display: flex;
      height: 181px;
      .wallet {
        width: 182px;
        background-color: #274077;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        img {
          width: 40px;
          height: 40px;
          margin-bottom: 20px;
        }
      }
      .lm-item {
        color: #fff;
        font-size: 48px;
        line-height: 1;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .lmi-text {
          margin-top: 20px;
          font-size: 14px;
        }
      }
    }
    .l-bottom {
      margin-top: 40px;
      padding: 48px 50px 70px;
      background-color: #fff;
      .lb-title {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .title {
          font-size: 20px;
          color: #333333;
          font-weight: bold;
        }
      }
      .lb-main {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        justify-content: center;
        .item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #4343442e;
          span {
            color: #333;
          }
          .count {
            margin-bottom: 20px;
            line-height: 1;
            color: #ff5c35;
            font-size: 48px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .right {
    margin-left: 1.95%;
    flex: 4;
    // flex: 0 1 670px;
    .rt-bottom {
      padding: 48px 50px;
      background-color: #fff;
      .rt-title {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .title {
          font-size: 20px;
          color: #333333;
          font-weight: bold;
        }
      }
      .rt-main {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        justify-content: center;
        .item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span {
            color: #333;
          }
          .count {
            margin-bottom: 20px;
            line-height: 1;
            color: #3992e9;
            font-size: 48px;
            font-weight: bold;
          }
        }
      }
    }
    .rt-section {
      display: flex;
      flex-wrap: wrap;
      .item {
        // width: 180px;
        flex: 0 0 45%;
        padding: 0 10px;
        height: 130px;
        line-height: 130px;
        background-color: #f0f3f6;
        margin-right: 5%;
        margin-top: 54px;
        color: #0f0e0e;
        text-align: center;
        font-size: 18px;
        font-weight: 800;
        transition: all 0.3s;
        &:hover {
          background-color: #3992e9;
          color: #fff;
        }
        span {
          color: #ff5c35;
        }
        &:nth-child(2n) {
          margin-left: 5%;
          margin-right: 0;
        }
      }
    }
    .rt-bottom.rb-bottom {
      padding: 45px 50px 40px;
    }
  }
}
</style>
